import { StructuredTextDocument } from "datocms-structured-text-to-html-string";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import StructuredTextGeneric from "./StructuredTextGeneric";

interface Props {
  fullname: string;
  jobTitleOrEmail: string;
  description: { value: Record<string, unknown> } | string;
  primaryPhoto: {
    alt: string;
    gatsbyImageData: Record<string, unknown>;
  };
  pagePath: string;
  itemType: "author" | "speaker";
}

const AuthorOrSpeakerItem = ({
  fullname,
  jobTitleOrEmail,
  description,
  primaryPhoto,
  pagePath,
  itemType,
}: Props) => {
  const data = Object.prototype.hasOwnProperty.call(description, "value")
    ? (description as unknown as StructuredTextDocument)
    : null;

  const splitNames = fullname.split(" ");
  const initials = splitNames[0].charAt(0) + splitNames[1].charAt(0);

  const itemComponentWrapperClassName =
    "group/wrapper gap-x-8 py-8 items-start first:mt-0 last:mb-0 sm:grid sm:grid-cols-author-item-sm md:grid-cols-author-item-md lg:grid-cols-author-item-lg block";
  const additionalFullnameClassName = pagePath
    ? "group-hover/wrapper:text-teal-600"
    : "";
  const fullnameClassName =
    "mt-4 sm:mt-0 text-xl md:text-2xl" + " " + additionalFullnameClassName;
  const imageClassName =
    "rounded-full w-16 h-16 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-36 lg:h-36";
  const placeholderClassName =
    "bg-teal-50 text-teal-700 flex items-center justify-center text-xl sm:text-3xl" +
    " " +
    imageClassName;

  const itemComponent = (
    <>
      <div className="flex h-16 w-16 items-center overflow-hidden rounded-full sm:h-28 sm:w-28 md:h-32 md:w-32 lg:h-36 lg:w-36">
        {!primaryPhoto ? (
          <div className={placeholderClassName}>{initials}</div>
        ) : (
          <GatsbyImage
            image={getImage(primaryPhoto)}
            alt={primaryPhoto.alt}
            className={imageClassName}
          />
        )}
      </div>
      <div className="flex flex-col justify-center sm:min-h-full">
        <p className={fullnameClassName}>{fullname}</p>
        <p className="text-gray-700">{jobTitleOrEmail}</p>
        {itemType === "author" ? (
          <p className="mt-4">{description as string}</p>
        ) : null}
        {itemType === "speaker" ? (
          <div className="mt-4">
            <StructuredTextGeneric data={data} isSpeakerItem />
          </div>
        ) : null}
      </div>
    </>
  );

  return pagePath ? (
    <Link
      to={pagePath}
      className={itemComponentWrapperClassName}
      key={fullname}
    >
      {itemComponent}
    </Link>
  ) : (
    <div className={itemComponentWrapperClassName} key={fullname}>
      {itemComponent}
    </div>
  );
};

export default AuthorOrSpeakerItem;
